import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------
const startDate = new Date();
let period = 'q3';
if (startDate.getMonth() < 3) period = 'q4';
else if (startDate.getMonth() < 6) period = 'q1';
else if (startDate.getMonth() < 9) period = 'q2';

const initialState = {
  isLoading: false,
  error: false,
  data: [],
  params: {
    year: startDate.getMonth() > 3 ? startDate.getFullYear() : startDate.getFullYear() - 1,
    period,
  },
};

const slice = createSlice({
  name: 'reportTax',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET REPORT
    getReportSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    },

    // SET PARAMS
    setParams(state, action) {
      state.params = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { setParams } = slice.actions;

// ----------------------------------------------------------------------

export function getReport(params = {}) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/report/tax', {
        params,
      });
      dispatch(slice.actions.getReportSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
